/* eslint-disable no-shadow */
import { Table } from 'appkit-react';

import './NestedTable.scss';

const NestedTable = ({ original, columns }) => {
    const renderSubComponent = (component, subComponentCols) => (
        <div style={{ padding: '5px 0 10px 5px' }}>
            <Table
                data={component.children}
                columns={subComponentCols}
                showPagination={false}
                showPaginationTop={false}
                showPaginationBottom={false}
                // eslint-disable-next-line react/jsx-no-bind
                SubComponent={row => {
                    if (row.original.children) {
                        return renderSubComponent(row.original, columns);
                    }
                    return <span />;
                }}
            />
        </div>
    );
    return (
        <div>
            {renderSubComponent(original, columns)}
        </div>
    );
};

export default NestedTable;
